const IMG_BB_API_KEYS = [
  "4b8d7989751c89d9561fd1e44100bf68",
  "2c5257b8de4e5bf05fc5a7b2419a418e",
  "62346dd09fb59412e2774c150742d3a4",
];

async function uploadWithKey(file, key) {
  const form = new FormData();
  form.append("image", file);

  const res = await fetch(`https://api.imgbb.com/1/upload?key=${key}`, {
    method: "POST",
    body: form,
  });

  // imgbb bəzən 200 qaytarıb success=false verir
  const data = await res.json().catch(() => null);

  if (!res.ok || !data || data?.success === false) {
    const msg =
      data?.error?.message ||
      data?.message ||
      `imgbb upload failed (status ${res.status})`;
    throw new Error(msg);
  }

  const url = data?.data?.url || data?.data?.display_url;
  if (!url) throw new Error("imgbb cavabında url tapılmadı.");
  return url;
}

/**
 * Upload 1 file to imgbb, try keys sequentially.
 * Returns image url.
 */
export async function uploadToImgbb(file) {
  let lastErr = null;

  for (const key of IMG_BB_API_KEYS) {
    try {
      return await uploadWithKey(file, key);
    } catch (e) {
      lastErr = e;
      // növbəti key ilə davam et
    }
  }

  throw new Error(
    lastErr?.message || "imgbb upload alınmadı (bütün key-lər uğursuz oldu)."
  );
}
